import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionsService {

  token = localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  getAllSections(per_page: number, pageNo: number, searchValue: string,) {
    return this.http.get(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/sections?&per_page=${per_page}&page=${pageNo}${searchValue === undefined || searchValue === '' ? '' : '&search=' + searchValue}`);
  }

  addSection(body) {
    return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/sections`, body)
  }

  updateSection(ScetionID, body) {
    return this.http.put(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/sections/${ScetionID}`, body)
  }

  deleteSection(ScetionID) {
    return this.http.delete(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/sections/${ScetionID}`)
  }

  private _sectionData = new BehaviorSubject<Object>(null);
  sectionData = this._sectionData.asObservable();


  setSectionData(section) {
    this._sectionData.next(section);
  }

  getSectionData() {
    return this._sectionData;
  }
}
